import React from "react";
import Toolbar from "@mui/material/Toolbar";
import AppBar from "@mui/material/AppBar";
import { Box, Typography, Avatar } from "@mui/material";
import slide3 from '../../media/slide3.jpg';

const Header = () => {
    return (
        <div>
            {/* <AppBar position="static">
                <Toolbar>
                    <Typography variant="h6">
                        <img src="/Images/logo_ft.png" />
                    </Typography>
                    <Typography variant="h6" component="div">
                        &nbsp;&nbsp;Customer Support Portal
                    </Typography>
                </Toolbar>
            </AppBar> */}

            <Box
                sx={{
                    backgroundImage: `url(${slide3})`,
                    backgroundPosition: "center center",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    height: "76px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "white",
                    textAlign: "center",
                    
                }}
            >
                <Typography variant="h5" sx={{display:"flex", flexDirection:"row", marginTop:"3px", fontWeight:"600"}}>
                     <img style={{height:"40px", marginLeft: "5px"}} src="/Images/logo_ft.png" />
                </Typography>
                <Typography variant="h6" sx={{ fontSize:"14px" }}>
                    Customer Support Portal
                </Typography>
            </Box>
        </div>
    );
};

export default Header;
